<ng-container *ngIf="ready">
    <ng-container *ngIf="ready">
        <div class="butonera">
            <button type="button" (click)="create()" mat-stroked-button
                class="btn btn-warning btn-circle btn-lg fc-black p-0">
                <mat-icon class="mat-icon-add-custom">add</mat-icon>
                <app-help key='Conceptos5'></app-help>
            </button>
        </div>

    </ng-container>

    <app-table [columns]="headerTable" [dataSource]="dataSource" [hasButton]="true" [actionsTemplate]="actionsButtons">
    </app-table>

    <ng-template #actionsButtons let-uid="uid">
        <ul class="custom-class">
            <li (click)="edit(uid)">
                <a>
                    <mat-icon>create</mat-icon>Editar
                </a>
            </li>
            <li (click)="delete(uid)">
                <a>
                    <mat-icon>warning</mat-icon>Borrar
                </a>
            </li>
        </ul>
    </ng-template>
</ng-container>

<ng-container *ngIf="empty">
    <div class="text-center">
        <img src="assets/icons/contacto.svg" class="invoiceImage">
        <p style="color: #9e9e9e">No tiene ninguna tarifa, presione + para crear uno.</p>
    </div>
</ng-container>

<ng-container *ngIf="!ready">
    <div class="container" style="height:65vh">
        <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
    </div>
</ng-container>
